export interface IEnvironment {
  name: string;
  version: string;
  url: string;
  identityServer: string;
  host: string;
}

export const environments = {
  dev: 'dev',
  testing: 'testing',
  staging: 'staging',
  production: 'production',
};
